// @ts-strict-ignore
import { useSelector } from 'react-redux';
import { selectIntegrationForCapability } from '../../selectors/selectors';
import { IntegrationCapability, IntegrationType } from '../../types';
import { RootState } from '../../reducers/reducers';

const useHasIntegrationTypeForCapability: (
    appId: string,
    integrationCapability: IntegrationCapability,
) => IntegrationType = (appId, integrationCapability) => {
    const integration = useSelector((state: RootState) =>
        selectIntegrationForCapability(state, appId, integrationCapability),
    );

    return integration?.id;
};

export default useHasIntegrationTypeForCapability;
